/**
 * Lecturas de la fila de la grilla de Móviles que cuelgan de la BASE del móvil.
 *
 * EL BUG QUE ORIGINÓ ESTO: las cuatro celdas leían `movil.base_eloquent.X` directo, chequeando
 * el último tramo pero no la base. `{movil.base_eloquent.pais && movil.base_eloquent.pais.nombre}`
 * revienta con "Cannot read properties of null (reading 'pais')" apenas aparece un móvil SIN
 * base, que es un caso perfectamente válido.
 *
 * *** POR QUÉ SE VE AL ORDENAR POR PAÍS Y NO ANTES ***
 * Los móviles sin base tienen país NULL, y MySQL pone los NULL primero en un ORDER BY ascendente.
 * O sea que ordenar por País los trae justo a la primera página: el bug estaba desde siempre pero
 * sólo se dispara cuando uno de esos móviles cae en la página que se está viendo. Por eso no
 * aparece en una grilla recién abierta.
 *
 * DE PASO SE ARREGLÓ QUE LA COLUMNA PAÍS MOSTRARA ALGO: leía `base.pais`, que es la FK, en vez de
 * la relación `base.pais_eloquent`. Estaba así desde antes y no daba error, sólo una celda vacía.
 *
 * Vive en su propio módulo porque el proyecto no tiene renderer de componentes en los tests: la
 * única forma de cubrir esto es que la lógica sea una función pura.
 *
 * React 16.8 / react-scripts 2.1.8: sin optional chaining, los chequeos van explícitos.
 */

/** Lo que se muestra cuando el móvil no tiene base: celdas vacías, no un error. */
const SIN_BASE = { pais: '', region: '', subRegion: '', base: '' };

const nombreDe = (entidad) => (entidad && entidad.nombre ? entidad.nombre : '');

/**
 * Los cuatro valores que la fila saca de la base del móvil, ya listos para renderizar.
 *
 * Cada tramo se chequea por separado porque cada uno puede faltar de forma independiente: hay
 * móviles sin base, bases sin país, y bases sin región o sin subregión.
 */
export const datosDeBase = (movil) => {
	const base = movil && movil.base_eloquent ? movil.base_eloquent : null;
	if (!base) return SIN_BASE;

	return {
		// `base.pais` es la FK (un id), no la relación: hacerle `.nombre` da undefined y por eso la
		// columna País venía SIEMPRE vacía, con o sin datos. La relación es `pais_eloquent`, que ya
		// viene cargada porque está en el `$with` del modelo Base, igual que region y sub_region.
		pais: nombreDe(base.pais_eloquent),
		region: nombreDe(base.region_eloquent),
		subRegion: nombreDe(base.sub_region_eloquent),
		base: base.descripcion ? base.descripcion : '',
	};
};

export default datosDeBase;
